import {query} from "./calls";

export const PublicFile = {
  getPublicFiles: (fileIds) => query(`SELECT id, url FROM PublicFile WHERE id in (${fileIds.join(',')})`),
  getPublicFile:(fileId) => query(`SELECT id, url FROM PublicFile WHERE id = ${fileId}`)
};
